export const blockIconsContentSort = (
	<span className='material-symbols-outlined'>sort</span>
);
